import TargetMenuModal from 'components/TargetMenuModal';
import service from 'features/DailyMenu/services';
import { CommonResponse, TargetMenu } from 'models';
import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { TARGET_MENU_DAILY_MENU } from 'utils';

interface AddHolidayDailyMenuButtonProps {
  holidayId: number;
}

function AddHolidayDailyMenuButton({ holidayId }: AddHolidayDailyMenuButtonProps) {
  const { t } = useTranslation();

  // states
  const [isOpenTargetMenuModal, setIsOpenTargetMenuModal] = useState(false);

  // events
  function handleOpenOverlayMenuModal() {
    setIsOpenTargetMenuModal(true);
  }

  function handleCloseOverlayMenuModal() {
    setIsOpenTargetMenuModal(false);
  }

  function handleLoadData(): Promise<CommonResponse<TargetMenu[]>> {
    return service.listHolidayMenus(holidayId);
  }

  function handleAdd(menuIds: number[]): Promise<CommonResponse<any>> {
    // compose add payload with overlayGroupId
    return service.addHolidayMenus(holidayId, menuIds);
  }

  function handleDelete(menuIds: number[]): Promise<CommonResponse<any>> {
    // compose delete payload with overlayGroupId
    return service.deleteHolidayMenus(holidayId, menuIds);
  }

  return (
    <>
      <Button className="ms-3" onClick={handleOpenOverlayMenuModal}>
        {t('DailyMenu.Button.target_menu')}
      </Button>
      {isOpenTargetMenuModal &&
        createPortal(
          <TargetMenuModal
            targetSourceType={TARGET_MENU_DAILY_MENU}
            targetName={'土日祝限定'}
            onLoadData={handleLoadData}
            onAdd={handleAdd}
            onDelete={handleDelete}
            onClose={handleCloseOverlayMenuModal}
          />,
          document.body
        )}
    </>
  );
}

export default AddHolidayDailyMenuButton;
